<template>
	<div class="com-container">
		<div class="com-chart" ref="rank_ref"></div>
	</div>
</template>

<script>
import axios from "axios";
export default {
	data() {
		return {
			chartInstance: null,
			allData: null,
			startValue: 0, // 区域缩放的起点值
			endValue: 9, // 区域缩放的终点值
			timerId: null, // 定时器的标识
		};
	},
	mounted() {
		this.initChart();
		this.getData();
		window.addEventListener("resize", this.screenAdapter);
		// 在页面加载完成的时候, 主动进行屏幕的适配
		this.screenAdapter();
	},
	destroyed() {
		clearInterval(this.timerId);
		// 在组件销毁的时候, 需要将监听器取消掉
		window.removeEventListener("resize", this.screenAdapter);
	},
	methods: {
		initChart() {
			this.chartInstance = this.$echarts.init(
				this.$refs.rank_ref,
				"chalk"
			);
			const initOption = {
				// 坐标系的位置
				grid: {
					left: "8%",
					top: "25%",
					right: "8%",
					bottom: "5%",
					containLabel: true, // 距离是包含坐标轴上的文字
				},
        // 标题
        title: {
          subtext:"百分比:(单位)",
        },
				// 提示框组件
				tooltip: {
					show: true,
				},
				xAxis: {
					type: "category",
          axisLabel:{
            color : "#fff"
          }
				},
				yAxis: {
					type: "value",
          axisLabel:{
            color : "#fff"
          }
				},
				series: [
					{
						type: "bar",
					},
				],
			};
			this.chartInstance.setOption(initOption);
			// 对图表对象进行鼠标事件的监听
			this.chartInstance.on("mouseover", () => {
				clearInterval(this.timerId);
			});
			this.chartInstance.on("mouseout", () => {
				this.startInterval();
			});
		},
		async getData() {
			const { data: ret } = await axios.get(
				"/right-bottom"
			);
			this.allData = ret.data;
			this.updateChart();
			// 启动定时器
			this.startInterval();
		},
		updateChart() {
			const colorArr = [
        ["#23D6F2","#033B62"],
				["#0BA82C", "#4FF778"],
				["#2E72BF", "#23E5E5"],
				["#5052EE", "#AB6EE5"],
			];

			// 所有省份形成的数组
			let provinceArr = this.allData.map((item) => {
				return item.name;
			});
			// 所有省份对应的销售金额
			let valueArr = this.allData.map((item) => {
				return item.value;
			});
			const dataOption = {
        // 标题
        title: {
          right: 10,
          top: 0,
        },
				xAxis: {
					data: provinceArr,

				},
				dataZoom: {
					show: false,
					startValue: this.startValue,
					endValue: this.endValue,
				},
				series: [
					{
						data: valueArr,
						itemStyle: {
							color: (arg) => {
								let targetColorArr = null;
                targetColorArr = colorArr[0];
								// if (arg.value > 300) {
								// 	targetColorArr = colorArr[0];
								// } else if (arg.value > 200) {
								// 	targetColorArr = colorArr[1];
								// } else {
								// 	targetColorArr = colorArr[2];
								// }
								return new this.$echarts.graphic.LinearGradient(
									0,
									0,
									0,
									1,
									[
										// 百分之0状态之下的颜色值
										{
											offset: 0,
											color: targetColorArr[0],
										},
										// 百分之100状态之下的颜色值
										{
											offset: 1,
											color: targetColorArr[1],
										},
									]
								);
							},
						},
					},
				],
			};
			this.chartInstance.setOption(dataOption);
		},
		// 定时器
		startInterval() {
			if (this.timerId) {
				clearInterval(this.timerId);
			}
			this.timerId = setInterval(() => {
				this.startValue++;
				this.endValue++;
				if (this.endValue > this.allData.length - 1) {
					this.startValue = 0;
					this.endValue = 9;
				}
				this.updateChart();
			}, 2000);
		},
		screenAdapter() {
			const titleFontSize = (this.$refs.rank_ref.offsetWidth / 100) * 3.6;
			const adapterOption = {
				// 标题
				title: {
					textStyle: {
						fontSize: titleFontSize,
					},
				},
				series: [
					{
						barWidth: titleFontSize, // 柱的高度
						itemStyle: {
							// 柱的圆角
							barBorderRadius: [
								titleFontSize / 2,
								titleFontSize / 2,
								0,
								0,
							],
						},
					},
				],
			};
			this.chartInstance.setOption(adapterOption);
			// 手动的调用图表对象的resize 才能产生效果
			this.chartInstance.resize();
		},
	},
};
</script>

<style>
</style>
